import { ref } from 'vue';

// Aba pendente para abrir no painel direito da conversa (ContactPanel).
// Compartilhado (module-scoped) para sobreviver à race: o header pode
// pedir a aba ANTES do ContactPanel montar (quando o painel estava fechado).
const pendingSidebarTab = ref(null);

export function useConversationSidebarTab() {
  const requestSidebarTab = tab => {
    pendingSidebarTab.value = tab;
  };
  const consumeSidebarTab = () => {
    const tab = pendingSidebarTab.value;
    pendingSidebarTab.value = null;
    return tab;
  };
  return { pendingSidebarTab, requestSidebarTab, consumeSidebarTab };
}
